import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/styles.scss';
import "@fortawesome/fontawesome-free/css/all.css";
import "./script";
import App from './App';
import { legacy_createStore } from "redux";
import { Provider } from 'react-redux'
import rootReducer from './components/rootReducer';

const store = legacy_createStore(rootReducer);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}><App /></Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

